module.exports = __webpack_public_path__ + "img/Weapon_20.f722cf0e.png";